import { Button } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';
import { usePreenchimentoContext } from 'pages/financeiro/dre/preenchimento/contexts';

export function PreenchimentoExportarRelatorioBtn() {
    const { filter } = useListagemContext();
    const { hasData } = usePreenchimentoContext();

    const requestOptions: RequestOptionsType = {
        url: '/dre/dremercadologica/relatoriopreenchimento/exportar',
        columns: 'idLoja,cdLoja,dsNomeFantasia,dtInicio,dtFim,idDreStatus,dsDreStatus,dsPeriodo',
        filter: filter,
    };

    const { isLoadingFile, downloadFile } = useDownloadFile({ requestOptions });

    const handleClickDownload = () => {
        downloadFile({
            newRequestOptions: requestOptions,
            directDownload: true,
        });
    };

    return (
        <Button
            variant="outlined"
            loading={isLoadingFile}
            onClick={handleClickDownload}
            disabled={!hasData || isLoadingFile}
            sx={{ color: 'green', borderColor: 'green' }}
            startIcon={<RiFileExcel2Fill />}
        >
            Relatório em .xlsx
        </Button>
    );
}
